import script from "./PageTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTitle.vue?vue&type=script&setup=true&lang=js"

import "./PageTitle.vue?vue&type=style&index=0&id=e15c12dc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\winkk\\Downloads\\交接\\20261021\\nsr-isso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e15c12dc"]])

export default __exports__